module.exports = __webpack_public_path__ + "img/index-4.a2075da0.png";